import { schema, types } from 'papr'

export const widgetSchema = schema(
	{
		publication: types.objectId({ required: true }),
		name: types.string({ required: true }),
		content: types.string({ required: true }),
		isActive: types.boolean(),
		dateAdded: types.date(),
		isPinned: types.boolean(),
		pinLocation: types.enum(['top' as const, 'bottom' as const]),
	},
	{
		timestamps: true,
		defaults: {
			isActive: true,
			isPinned: false,
		},
	},
)

export type WidgetDocument = (typeof widgetSchema)[0]
export type WidgetDefaults = (typeof widgetSchema)[1]
